import ScrollableImmagini from "./ScrollableImmagini";
import React from "react";

export default function ScrollabileRiga({idTitolo,titolo,idScroll1,idScroll2,dati,tipo,sottoTipo1,sottoTipo2,nomeDati}){
    

    function handleHorizontalScroll(e, id) {
        const scrollable = document.getElementById(id);
    
        if (e.shiftKey) {
        
        if (e.deltaY > 0) {
            scrollable.scrollLeft += 50;
        } else {
            scrollable.scrollLeft -= 50;
        }
        }
    }

    return (
        <>
            <h1 className="titoloCategoria" id={idTitolo}>{titolo}</h1>
            <div className="riga">
                <div className="figlio">
                    <div className="shop-content" id={idScroll1} onWheel={event=>handleHorizontalScroll(event,idScroll1)}>
                        
                        {
                            dati && dati[tipo][sottoTipo1].map((elem,index)=><ScrollableImmagini titolo={elem.titolo} prezzo={elem.prezzo} immagine={elem.immagine} elemento={`${nomeDati}-${tipo}-${sottoTipo1}-${index}`} key={elem.id}/>)
                        }
                        
                    </div>
                </div>
                <div className="figlio">
                    <div className="shop-content" id={idScroll2}  onWheel={event=>handleHorizontalScroll(event,idScroll2)}>
                        
                        {
                            dati && dati[tipo][sottoTipo2].map((elem,index)=><ScrollableImmagini titolo={elem.titolo} prezzo={elem.prezzo} immagine={elem.immagine} elemento={`${nomeDati}-${tipo}-${sottoTipo2}-${index}`} key={elem.id}/>)
                        }
                        
                    </div>
                </div>
            </div>
        </>
    )
}